import qs from 'qs'
import request from '@/utils/request'
import { exportFile } from '@/utils/fileExport'

// ==================== 认证 ====================

// 账号密码登录
export function doLogin (data) {
  return request({ url: '/ajef-user/doLogin', method: 'post', data: qs.stringify(data) })
}

// 刷新用户信息（含权限树）
export function getUserDetailsRefresh () {
  return request({ url: '/ajef-user/getAjefUserDetails', method: 'post' })
}

// ==================== 用户管理 ====================

// 用户列表（分页）
export function getAjefUserList (data) {
  return request({ url: '/ajef-user/getAjefUserList', method: 'post', data: qs.stringify(data) })
}

// 用户详情
export function getAjefUserDetails (data) {
  return request({ url: '/ajef-user/getAjefUserDetails', method: 'post', data: qs.stringify(data) })
}

// 新增用户
export function addAjefUser (data) {
  return request({ url: '/ajef-user/addAjefUser', method: 'post', data: qs.stringify(data) })
}

// 编辑用户
export function updateAjefUser (data) {
  return request({ url: '/ajef-user/updateAjefUser', method: 'post', data: qs.stringify(data) })
}

// 修改自己的密码
export function updateAjefUserPw (data) {
  return request({ url: '/ajef-user/updateAjefUserPw', method: 'post', data: qs.stringify(data) })
}

// 删除用户（逻辑删除）
export function deleteAjefUser (data) {
  return request({ url: '/ajef-user/deleteAjefUser', method: 'post', data: qs.stringify(data) })
}

// ==================== 商户用户 ====================

// 商户用户列表（分页）
export function getAjefUserShopList (data) {
  return request({ url: '/ajef-user-shop/getAjefUserShopList', method: 'post', data: qs.stringify(data) })
}

// ==================== 商户订单 ====================

// 商户订单列表（分页）
export function getAjefOrderShopList (data) {
  return request({ url: '/ajef-order-shop/getAjefOrderShopList', method: 'post', data: qs.stringify(data) })
}

// 导出商户订单 Excel
export function exportAjefOrderShop (data) {
  return exportFile({
    url: '/ajef-order-shop/exportAjefOrderShop',
    data,
    defaultFileName: '商户订单.xlsx'
  })
}

// ==================== 操作日志 ====================

// 操作日志列表（分页）
export function getSysLogList (data) {
  return request({ url: '/sys-log/getSysLogList', method: 'post', data: qs.stringify(data) })
}

// ==================== 日志归档 ====================

// 归档日志列表（分页）
export function getSysLogCopyList (data) {
  return request({ url: '/sys-log-copy/getSysLogCopyList', method: 'post', data: qs.stringify(data) })
}

// 日志迁移
export function updateSysLogCopyDo (data) {
  return request({ url: '/sys-log-copy/updateSysLogCopyDo', method: 'post', data: qs.stringify(data) })
}

// ==================== 日志活跃统计 ====================

// 统计列表（分页）
export function getSysLogStatisticsList (data) {
  return request({ url: '/sys-log-statistics/getSysLogStatisticsList', method: 'post', data: qs.stringify(data) })
}

// 统计时间段详情
export function getSysLogStatisticsDetails (data) {
  return request({ url: '/sys-log-statistics/getSysLogStatisticsDetails', method: 'post', data: qs.stringify(data) })
}

// ==================== 通知 ====================

// 通知列表（分页）
export function getSysNoticeList (data) {
  return request({ url: '/sys-notice/getSysNoticeList', method: 'post', data: qs.stringify(data) })
}

// 通知标题分类
export function getSysNoticeListTitle () {
  return request({ url: '/sys-notice/getSysNoticeListTitle', method: 'post' })
}

// 未读数量
export function getSysNoticeUnReadNum () {
  return request({ url: '/sys-notice/getSysNoticeUnReadNum', method: 'post' })
}

// 标记已读
export function updateSysNoticeRead (noticeIds) {
  return request({ url: '/sys-notice/updateSysNoticeRead', method: 'post', data: qs.stringify({ noticeIds: JSON.stringify(noticeIds) }) })
}

// 一键已读
export function updateSysNoticeReadAll () {
  return request({ url: '/sys-notice/updateSysNoticeReadAll', method: 'post' })
}

// 删除通知
export function deleteSysNoticeRead (noticeIds) {
  return request({ url: '/sys-notice/deleteSysNoticeRead', method: 'post', data: qs.stringify({ noticeIds: JSON.stringify(noticeIds) }) })
}

// ==================== 短信注册记录 ====================

// 短信记录列表（分页）
export function getSysRegisterCodeList (data) {
  return request({ url: '/sys-register-code/getSysRegisterCodeList', method: 'post', data: qs.stringify(data) })
}

// ==================== 腾讯云文件 ====================

// 获取上传秘钥
export function getPolicyTxCloudEquityFee () {
  return request({ url: '/tx-cloud-file/getPolicyTxCloudEquityFee', method: 'post' })
}

// 上传文件到腾讯云
export function uploadFileToTxCloudEquityFee (file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({ url: '/tx-cloud-file/uploadFileToTxCloudEquityFee', method: 'post', data: formData })
}
